<template>
	<div class="page">
		<HeaderBar title="乙肝两对半定量"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400ldbdl.guid">
					<checkItem v-for="(item,index) in dataList" :key="index" v-model="form.bq400ldbdl" :config="item"
						@setFormData="setFormData">
					</checkItem>
				</van-cell-group>
				<FormNormalUpload label="查看报告" ref="normalUpload" :infoGuid='form.bq400ldbdl.guid' disabled>
				</FormNormalUpload>

			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page002",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400ldbdl',
				form: {
					bq400ldbdl: {
						id: "", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400048: "", //乙肝表面抗原
						bq4000482: "", //值
						bq4000483: "", //单位
						bq400049: "", //乙肝表面抗体
						bq4000492: "", //值
						bq4000493: "", //单位
						bq400050: "", //乙肝e抗原
						bq4000502: "", //值
						bq4000503: "", //单位
						bq400051: "", //乙肝e抗体
						bq4000512: "", //值
						bq4000513: "", //单位
						bq400052: "", //乙肝核心抗体
						bq4000522: "", //值
						bq4000523: "", //单位
						Bq400_guid: '', //随访基本信息表编号
						Bq400_048: '', //乙肝表面抗原
						Bq400_048_2: '', //值
						Bq400_048_3: '', //单位
						Bq400_049: '', //乙肝表面抗体
						Bq400_049_2: '', //值
						Bq400_049_3: '', //单位
						Bq400_050: '', //乙肝e抗原
						Bq400_050_2: '', //值
						Bq400_050_3: '', //单位
						Bq400_051: '', //乙肝e抗体
						Bq400_051_2: '', //值
						Bq400_051_3: '', //单位
						Bq400_052: '', //乙肝核心抗体
						Bq400_052_2: '', //值
						Bq400_052_3: '', //单位
					},
					sempFiles: []
				},
				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/S400/bq400ldbdl/',
				dataList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400'))
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400ldbdl/Info', args, function(d) {
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$set(that.form, "bq400ldbdl", dataModel)
					}
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400ldbdl.bq400guid = this.bq400.guid
			this.LoadDataList()
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
